import CorporateBusinessCanvasView from '@qpr/corporate-business-canvas';
import React, { useContext, useEffect } from 'react';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import cbcViewModel from '../modules/CorporateBusinessCanvas/views/corporate-business-canvas-view-model';
import BMCPage from './BMC';

const CBCPage = ({ elementId = null }: any) => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  const { rootElementId } = useParams<{ rootElementId: string }>();
  const { path } = useRouteMatch();

  const viewModel = cbcViewModel(elementId || rootElementId);
  return (
    <Switch>
      <Route path={`${path}bmc/:corporateId/`} component={BMCPage} />
      <Route path={`${path}:corporateId/`} component={BMCPage} />
      <Route>
        <CorporateBusinessCanvasView CBCViewModel={viewModel} />
      </Route>
    </Switch>
  );
};

export default CBCPage;
